import { render, staticRenderFns } from "./AddScene.vue?vue&type=template&id=6a285a6b&scoped=true&"
import script from "./AddScene.vue?vue&type=script&lang=js&"
export * from "./AddScene.vue?vue&type=script&lang=js&"
import style0 from "./AddScene.vue?vue&type=style&index=0&id=6a285a6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a285a6b",
  null
  
)

export default component.exports